import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { tpoGenUrls } from 'config/urls';
import { sendNotification } from 'utils/helperMethods';

import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import type { ResetPromoLibraryKpisRequest, ResetPromoLibraryKpisResponse } from '../../types';

const resetKpis = async (body: ResetPromoLibraryKpisRequest): Promise<ResetPromoLibraryKpisResponse> => {
    let token = '';
    try {
        token = localStorage.getItem('accessToken') ?? '';
    } catch {
        // incognito / disabled storage
    }

    const response = await axios(tpoGenUrls.resetPromoLibrary, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: body,
    });
    return response.data;
};

interface UseResetPromoLibraryKpisMutationOptions {
    onSuccess?: () => void;
}

const useResetPromoLibraryKpisMutation = ({ onSuccess }: UseResetPromoLibraryKpisMutationOptions = {}) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: resetKpis,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.promoLibrary() });
            sendNotification('success', data.message ?? 'KPIs reset successfully');
            onSuccess?.();
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.detail ??
                error?.response?.data?.message ??
                error?.message ??
                'Failed to reset KPIs';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useResetPromoLibraryKpisMutation;
